import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { computed } from 'vue';
import { useUserStore } from '@/store';

export default function usePermission() {
  const userStore = useUserStore();
  const permissions = computed(() => {
    return userStore.permissions || [];
  });
  return {
    accessRouter(route: any) { // 判断当前用户是否有该路由的权限
      // return (
      //   !route.meta?.requiresAuth ||
      //   !route.meta?.roles ||
      //   route.meta?.roles?.includes('*') ||
      //   route.meta?.roles?.includes(userStore.role)
      // );
      return (
        !route.meta?.requiresAuth ||
        !route.meta?.roles ||
        route.meta?.roles?.includes('**') ||
        permissions.value.includes(route.meta?.permission)
      );
    },
    // You can add any rules you want
    findFirstPermissionRoute(_routers: any, role = 'admin') {
      const cloneRouters = [..._routers];
      while (cloneRouters.length) {
        const firstElement = cloneRouters.shift();
        if (
          firstElement?.meta?.roles?.find((el: string[]) => {
            return el.includes('*') || el.includes(role);
          })
        )
          return { name: firstElement.name };
        if (firstElement?.children) {
          cloneRouters.push(...firstElement.children);
        }
      }
      return null;
    },
    // You can add any rules you want
  };
}
